import { useEffect, useState } from 'react';
import { OrderRefundReasonPage } from './seller/OrderRefundReasonPage';
import { DesktopOrderRefundReasonPage } from './desktop/DesktopOrderRefundReasonPage';

export function ResponsiveOrderRefundReasonPage() {
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  return isMobile ? <OrderRefundReasonPage /> : <DesktopOrderRefundReasonPage />;
}